module.exports = __webpack_public_path__ + "img/jilu.2e02714d.png";